import Vue from 'vue';
import App from './App.vue';
// import './registerServiceWorker';
import router from './router/router';
import store from './store';
import vuetify from './plugins/vuetify';
import {getCookie} from '@/services/AuthService';
import Highcharts from 'highcharts';
import HighchartsVue from 'highcharts-vue';
import boost from 'highcharts/modules/boost';

Vue.use(HighchartsVue);
boost(Highcharts);

Vue.config.productionTip = false;

async function init() {
  await getCookie();

  new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
  }).$mount('#app');
}

init().then();
